import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Typography, Tooltip, Pagination, notification, Col } from 'antd';
import { AgGridReact } from 'ag-grid-react';
import 'common/components/ag-grid/registerAgGridModules';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import moment from 'moment';
import { dialogFunction } from 'common/components/index';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { injectIntl } from 'react-intl';
import Messages from 'i18n/messages/folder';
import * as folderService from 'services/folder';
import DigitalRightIcon from 'common/components/digital-right-icon/DigitalRightIcon';
import { useDispatchReloadPage } from 'hooks/useReloadPage';

import {
  DeleteOutlined,
  CodeSandboxOutlined,
  PlaySquareOutlined,
  UserOutlined,
  QuestionOutlined,
  SearchOutlined,
  SnippetsOutlined,
} from '@ant-design/icons';


const { Title } = Typography;

function iconRenderer(params) {
  if (params.data.type.toLowerCase() === 'product')
    return (
      <>
        <Tooltip title='Click for preview'>
          <CodeSandboxOutlined />
        </Tooltip>
        {params.data.drm && (
          <DigitalRightIcon
            size='small'
            className='folder-panel-content__drm-grid'
          />
        )}
      </>
    );
  else if (params.data.type === 'asset')
    return (
      <>
        <Tooltip title='Click for preview'>
          <PlaySquareOutlined />
        </Tooltip>
        {params.data.drm && (
          <DigitalRightIcon
            size='small'
            className='folder-panel-content__drm-grid'
          />
        )}
      </>
    );
  else if (params.data.type === 'member')
    return (
      <>
        <Tooltip title='Click for preview'>
          <UserOutlined />
        </Tooltip>
        {params.data.drm && (
          <DigitalRightIcon
            size='small'
            className='folder-panel-content__drm-grid'
          />
        )}
      </>
    );
  else if (params.data.type === 'Query')
    return (
      <>
        <Tooltip title='Click for preview'>
          <SearchOutlined />
        </Tooltip>
        {params.data.drm && (
          <DigitalRightIcon
            size='small'
            className='folder-panel-content__drm-grid'
          />
        )}
      </>
    );
  else if (params.data.type === 'Reporting')
    return (
      <>
        <Tooltip title='Click for preview'>
          <SnippetsOutlined />
        </Tooltip>
        {params.data.drm && (
          <DigitalRightIcon
            size='small'
            className='folder-panel-content__drm-grid'
          />
        )}
      </>
    );
  else return <QuestionOutlined />;
}

function dateFormatter(params) {
  return moment(params.value).format('MM/DD/YYYY');
}

function convertNodeData(nodes) {
  const result = nodes.map((node) => node.data);
  return result;
}

function coverNewData(rowsSelection, gridRowsSelection, itemSelection) {
  let result = rowsSelection;

  const idxRows = result.findIndex((row) => row.id === itemSelection.id);
  const idxGridRows = gridRowsSelection.findIndex(
    (row) => row.id === itemSelection.id
  );

  if (idxRows !== -1 && idxGridRows === -1) {
    result = result.filter((row) => row.id !== itemSelection.id);
    return result;
  }

  // Set value: { {}, {} } -> Array.from -> [{}, {}]
  result = Array.from(new Set([...rowsSelection, ...gridRowsSelection]));
  return result;
}

const PanelContent = (props) => {
  const dispatch = useDispatch();
  const reloadPage = useDispatchReloadPage();

  const { ownerFolder, shortDetail, seePreview, isEdit, intl } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);

  const [gridApi, setGridApi] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedItem, setSelectedItem] = useState();

  useEffect(() => {
    if (!gridApi) return;

    gridApi.forEachNode((node) => {
      const idxRow = selectedRows.findIndex(
        (selectedRow) => selectedRow.id === node.data.id
      );
      if (idxRow !== -1) {
        node.setSelected(true);
      } else {
        node.setSelected(false);
      }
    });
    setSelectedItem({});
  }, [currentPage, gridApi, selectedRows]);

  const getAgGridProps = (pageRows) => {
    return {
      headerHeight: 32,
      rowHeight: 32,
      rowSelection: 'multiple',
      // rowMultiSelectWithClick: true,
      rowData: pageRows,
      // without a row id, AG Grid rebuilds rows on new rowData and clears the selection
      getRowId: ({ data }) => String(data.id),
      pivotPanelShow: 'never',
      onRowClicked: (params) => {
        setSelectedItem(params.data);
        // setSelectedRows([params.data]);
      },
      onRowDoubleClicked: (params) => {
        if (seePreview) seePreview(params.data);
      },
      onSelectionChanged: () => {
        const selectedNodes = gridApi.getSelectedNodes();
        const selectedDataNodes = convertNodeData(selectedNodes);
        // const result = coverNewData(
        //   selectedRows,
        //   selectedDataNodes,
        //   selectedItem
        // );
        setSelectedRows(selectedDataNodes);
      },
      onCellClicked: (params) => {
        if (params.colDef.field === '' && seePreview) seePreview(params.data);
      },
      onGridReady: onGridReady,
    };
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  const gridColumn = [
    {
      key: '1',
      field: '',
      width: 70,
      cellRenderer: iconRenderer,
      menuTabs: [],
    },
    // {
    //   key: '2',
    //   field: 'drm',
    //   cellRendererFramework: digitalRightIconRender,
    //   width: 30,
    //   menuTabs: [],
    // },
    {
      key: '2',
      field: 'description',
      width: 300,
      menuTabs: [],
    },
    {
      key: '3',
      field: 'dateAdded',
      cellRenderer: dateFormatter,
      width: 130,
      menuTabs: [],
    },
  ];
  const rowData = useMemo(
    () => shortDetail?.folderContents ?? [],
    [shortDetail?.folderContents]
  );

  const pageRows = useMemo(
    () =>
      rowData.filter(
        (item, index) =>
          index >= (currentPage - 1) * currentPageSize &&
          index <= currentPageSize * currentPage - 1
      ),
    [rowData, currentPage, currentPageSize]
  );

  const confirmDelete = () => {
    if (selectedRows.length > 0) {
      dialogFunction({
        type: 'warn',
        content: intl.formatMessage(Messages.areYouSureToDelete),
        onOk: callApiDelete,
      });
    } else {
      notification.warn({
        message: 'Must select at least one items to delete.',
      });
    }
  };

  const callApiDelete = async () => {
    const itemList = selectedRows.map((item) => {
      return { id: item.id, type: item.type };
    });

    try {
      const response =
        await folderService.deleteEntityAssocicationFromShortContent({
          folderId: shortDetail?.id,
          itemList,
        });
      const { isSuccess, message } = response;
      if (isSuccess) {
        if (currentPage !== 1) {
          setCurrentPage(1);
        }
        setSelectedRows([]);

        showSuccessMessageDialog();
        reloadPage();
      } else {
        callApiErrorHandler(message);
      }
    } catch (error) {
      callApiErrorHandler(error);
    }
  };

  const showSuccessMessageDialog = () => {
    notification.success({
      message: intl.formatMessage(Messages.deleteSuccess),
    });
  };

  const callApiErrorHandler = (error) => {
    notification.error({
      message: error,
    });
  };

  return (
    <div className='folder-panel-content'>
      <Row justify='space-between'>
        <Title
          className='folder-panel-content__folder-name'
          style={{ fontSize: '16px' }}
        >
          {intl.formatMessage({
            id: 'Taco.folder.components.contentPane.content',
          })}
        </Title>
        {isEdit && (
          <div className='folder-panel-content__content-button'>
            <Tooltip
              title={intl.formatMessage({
                id: 'Taco.folder.components.contentPane.delete',
              })}
            >
              <DeleteOutlined
                onClick={confirmDelete}
                className={'folder-panel-content__button'}
              />
            </Tooltip>
          </div>
        )}
      </Row>

      <div
        id='folder-panel-content__grid'
        style={{ height: 270, width: '100%', marginTop: 10 }}
        className='ag-theme-alpine'
      >
        <AgGridReact theme="legacy" {...getAgGridProps(pageRows)} columnDefs={gridColumn} />
      </div>
      <div className='folder-panel-content__pagination'>
        <Pagination
          showSizeChanger
          onChange={(page, size) => {
            setCurrentPage(page);
            setCurrentPageSize(size);
          }}
          pageSize={currentPageSize}
          defaultCurrent={currentPage}
          total={rowData && rowData.length}
        />
      </div>
      {rowData.filter((item) => item.drm).length > 0 && (
        <Row style={{ marginTop: 20 }}>
          <Col span={2}>
            <DigitalRightIcon width={35} height={35} />
          </Col>
          <Col span={22} style={{ fontWeight: 500 }}>
            {intl.formatMessage({
              id: 'Taco.common.components.folderDRM',
            })}
          </Col>
        </Row>
      )}
    </div>
  );
};

export default injectIntl(PanelContent);
